export class CaptureImageError {
  public message: string = null;
}
